/** 富文本中视为「有内容」的媒体标签 */
const RICH_TEXT_MEDIA_TAG_PATTERN = /<(img|video|iframe|embed|audio)\b/i;

/**
 * 判断富文本是否有有效内容（文字或图片/视频等媒体）
 * 仅含空白、换行或 &nbsp; 时视为空
 */
export function hasRichTextContent(html?: string | null): boolean {
    if (!html) {
        return false;
    }

    if (RICH_TEXT_MEDIA_TAG_PATTERN.test(html)) {
        return true;
    }

    return !!html
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, '')
        .replace(/\u200b/g, '')
        .trim();
}

/**
 * @deprecated 使用 hasRichTextContent
 */
export function isRichTextEmpty(html?: string | null): boolean {
    return !hasRichTextContent(html);
}
